import React, { useEffect, useState, useCallback } from 'react'
import axios from "axios"
import { useParams } from 'react-router-dom'
import Footer from './footer'
import "./style/Shop.css"
import HeroImage from './ShowHero'
import ReviewComponent from './ReviewComponent'
import { useNavigate, Link } from 'react-router-dom'
import ShareButton from './ShareButton'
import OrderModal from './OrderModal'
import Adhero from './Adhero'

export default function ShopProducts() {
const { slug } = useParams()
const [id, setId] = useState(null)
const [products, setProducts] = useState([])
const [search, toSearch] = useState("")
const [showcart, setShowcart] = useState(false)
const [shopEmail, setShopEmail] = useState("")
const [shopName, setShopName] = useState("")
const [toast, setToast] = useState(null)
const [expandedProductId, setExpandedProductId] = useState(null)
const [showOrderModal, setShowOrderModal] = useState(false)
const [isSubmitting, setIsSubmitting] = useState(false)
const navigate = useNavigate()
const api = "https://mkbackend-production.up.railway.app"

useEffect(() => {
    const getShop = async () => {
        try {
            const res = await axios.get(`${api}/public-shop/${slug}`)
            setId(res.data.shop._id)
        } catch (error) {
            console.log(error)
        }
    }
    getShop()
}, [slug])

useEffect(() => {
    const savedShopEmail = localStorage.getItem(`shop-email-${slug}`)
    const savedShopName = localStorage.getItem(`shop-name-${slug}`)
    if (savedShopEmail) setShopEmail(savedShopEmail)
    if (savedShopName) setShopName(savedShopName)
}, [slug])

const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem(`cart-${slug}`)
    return saved ? JSON.parse(saved) : []
})
const addToCart = (item) => {
    setCart((prevCart) => {
        const existingItem = prevCart.find(
            cartItem => cartItem._id === item._id
        );

        let updatedCart;

        if (existingItem) {
            updatedCart = prevCart.map(cartItem =>
                cartItem._id === item._id
                    ? {
                        ...cartItem,
                        quantity: (cartItem.quantity || 1) + 1
                    }
                    : cartItem
            );
        } else {
            updatedCart = [
                ...prevCart,
                {
                    ...item,
                    quantity: 1,

                    // IMPORTANT
                    shopId: id,
                    shopSlug: slug
                }
            ];
        }

        localStorage.setItem(
            `cart-${slug}`,
            JSON.stringify(updatedCart)
        );

        return updatedCart;
    });

    showToast(`${item.name} added to cart!`);
};
const removeFromCart = (itemId) => {
    setCart((prevCart) => {
        const updatedCart = prevCart.filter(item => item._id !== itemId)
        localStorage.setItem(`cart-${slug}`, JSON.stringify(updatedCart))
        return updatedCart
    })
    showToast('Item removed from cart')
}

const updateQuantity = (itemId, newQuantity) => {
    if (newQuantity < 1) {
        removeFromCart(itemId)
        return
    }

    setCart((prevCart) => {
        const updatedCart = prevCart.map(item =>
            item._id === itemId
                ? { ...item, quantity: newQuantity }
                : item
        )
        localStorage.setItem(`cart-${slug}`, JSON.stringify(updatedCart))
        return updatedCart
    })
}

const showToast = (message) => {
    setToast(message)
    setTimeout(() => {
        setToast(null)
    }, 3000)
}

const fetchProducts = useCallback(async () => {
    if (!id) return

    try {
        const res = await axios.get(
            `${api}/shop-products/${id}`
        )
        setProducts(res.data.products)

        try {
            const shopRes = await axios.get(
                `${api}/public-shop/${slug}`
            )

            if (shopRes.data.shop) {
                const name = shopRes.data.shop.shopName || shopRes.data.shop.email
                setShopName(name)
                localStorage.setItem(`shop-name-${slug}`, name)

                if (shopRes.data.shop.email) {
                    setShopEmail(shopRes.data.shop.email)
                    localStorage.setItem(`shop-email-${slug}`, shopRes.data.shop.email)
                }
            }
        } catch (shopError) {
            console.log("Error fetching shop details:", shopError)

            if (res.data.products && res.data.products.length > 0) {
                const firstProduct = res.data.products[0]
                if (firstProduct.owner && firstProduct.owner.shopName) {
                    const name = firstProduct.owner.shopName
                    setShopName(name)
                    localStorage.setItem(`shop-name-${slug}`, name)
                }
            }
        }
    } catch (error) {
        console.error("Error fetching products:", error)
    }
}, [id, slug, api])

useEffect(() => {
    fetchProducts()
}, [fetchProducts])

const toggleCart = () => {
    setShowcart(!showcart)
}

const handlePlaceOrder = () => {
    if (cart.length === 0) {
        showToast('Your cart is empty!')
        return
    }
    setShowOrderModal(true)
    setShowcart(false)
}

const orderSubmit = async (customerDetails) => {
    setIsSubmitting(true)
    try {
        const productsData = cart.map((item) => ({
            productId: item._id,
            slug: item.slug,
            quantity: item.quantity || 1,
            price: item.price
        }))

        await axios.post(
            `${api}/order`,
            {
                products: productsData,
                shopId: id,
                customerDetails: customerDetails
            }
        )

        showToast('🎉 Order placed successfully! Check your email.')
        setCart([])
        localStorage.removeItem(`cart-${slug}`)
        setShowOrderModal(false)

    } catch (error) {
        console.log(error)
        showToast('❌ Error placing order. Please try again.')
    } finally {
        setIsSubmitting(false)
    }
}

const getTotalPrice = () => {
    return cart.reduce((total, item) => total + (item.price * (item.quantity || 1)), 0).toFixed(2)
}

return (
    <div>
        {/* <Adhero /> */}
        {toast && (
            <div className="toast">
                {toast}
            </div>
        )}

        <OrderModal
            isOpen={showOrderModal}
            onClose={() => setShowOrderModal(false)}
            onSubmit={orderSubmit}
            totalAmount={getTotalPrice()}
            isLoading={isSubmitting}
        />

        <div
            className={`cart-overlay ${showcart ? 'open' : ''}`}
            onClick={toggleCart}
        ></div>

        <div className={`cart-sidebar ${showcart ? 'open' : ''}`}>
            <div className="cart-header">
                <h3>Shopping Cart</h3>
                <button className="cart-close" onClick={toggleCart}>✕</button>
            </div>

            <div className="cart-items">
                {cart.length === 0 ? (
                    <div className="cart-empty">
                        <span className="cart-empty-icon">🛒</span>
                        <h4>Your cart is empty</h4>
                        <p>Start shopping to add items!</p>
                    </div>
                ) : (
                    cart.map((item, index) => (
                        <div key={index} className="cart-item">
                            <img src={item.image} alt={item.name || 'Product'} />
                            <div className="cart-item-details">
                                <div className="cart-item-name">{item.name}</div>
                                <div className="cart-item-price">Rs: {item.price}</div>
                                <div className="cart-item-quantity">
                                    <button onClick={() => updateQuantity(item._id, (item.quantity || 1) - 1)}>−</button>
                                    <span>{item.quantity || 1}</span>
                                    <button onClick={() => updateQuantity(item._id, (item.quantity || 1) + 1)}>+</button>
                                </div>
                            </div>
                            <button
                                className="cart-item-remove"
                                onClick={() => removeFromCart(item._id)}
                            >
                                ✕
                            </button>
                        </div>
                    ))
                )}
            </div>

            {cart.length > 0 && (
                <div className="cart-footer">
                    <div className="cart-total">
                        <span>Total:</span>
                        <span>Rs: {getTotalPrice()}</span>
                    </div>
                    <button className="cart-checkout-btn" onClick={handlePlaceOrder}>
                        🛒 Proceed to Checkout
                    </button>
                </div>
            )}
        </div>

        <div className="navBar">
            <h2>MK Shop</h2>
            <div className="nav-actions" style={{display:"flex" , gap:"5px"}}>
                <button onClick={toggleCart} className="cart-btn">
                    🛒 Cart
                    <span className="cart-badge">{cart.length}</span>
                </button>
                <ShareButton shopId={slug} shopName={shopName} />
            </div>
        </div>

        <div className="shop-hero-section">
            <HeroImage shopId={id} />
        </div>

        <div className="products">
            <input
                type="text"
                placeholder="🔍 Search products..."
                onChange={(e) => toSearch(e.target.value)}
                value={search}
            />

            <div className="product">
                {products.length === 0 ? (
                    <p className="no-products">No products found</p>
                ) : (
                    products
                        .filter((product) =>
                            product.name
                                .toLowerCase()
                                .includes(search.toLowerCase())
                        )
                        .map((item) => (
                            <div key={item._id} className="product-card" onClick={() => navigate(`/${slug}/${item.slug}`)}>
                                <img src={item.image} alt={item.name || 'Product'} />
                                <h3>{item.name}</h3>
                                <p>Rs:{item.price}</p>

                                {item.averageRating > 0 && (
                                    <div className="product-rating-display">
                                        <span className="stars">
                                            {'⭐'.repeat(Math.round(item.averageRating))}
                                        </span>
                                        <span className="rating-text">
                                            {item.averageRating.toFixed(1)}
                                            <span className="review-count">
                                                ({item.totalReviews || 0} reviews)
                                            </span>
                                        </span>
                                    </div>
                                )}

                                <button onClick={(e) => { e.stopPropagation(); addToCart(item)}} className="add-to-cart-btn">
                                    Add to Cart
                                </button>

                                {expandedProductId === item._id && (
                                    <div className="product-reviews-section" onClick={(e) => e.stopPropagation()}>
                                        <ReviewComponent productId={item._id} />
                                    </div>
                                )}
                            </div>
                        ))
                )}
            </div>
        </div>

        <div className="ai-button-container">
            <Link
                to="/ai-dashboard"
                className="ai-button ai-button-tooltip"
                aria-label="Open AI Assistant"
            >
                <span className="ai-icon">🤖</span>
                <span className="ai-text">AI Assistant</span>
                <span className="ai-badge">NEW</span>
            </Link>
        </div>

        <Footer />
    </div>
)
}